<template>
  <v-form @submit.prevent="save" ref="myForm">
    <div class="myCard">
      <!-- -------------------------------------------------------------------------- -->
      <!---------------------- En tête de l'event info card  ------------------------ -->
      <!-- -------------------------------------------------------------------------- -->
      <div
        class="title"
        flat
        v-bind:style="
          eventSelected.eventSiblings.length > 0 || tasksBetween.length > 0
            ? { backgroundColor: 'gainsboro', color: 'white' }
            : eventSelected.details.validated
            ? eventSelected.details.type === 'INTRA'
              ? {
                  backgroundColor: '#ffd320',
                  color: eventSelected.color,
                  fontWeight: 'bold',
                }
              : {
                  background: eventSelected.color,
                  color: '#ffffff',
                  fontWeight: 'bold',
                }
            : {
                background: '#FFFFCC',
                color: eventSelected.color,
                fontWeight: 'bold',
              }
        "
      >
        <div class="head-card">
          <div class="icons">
            <div
              class="id"
              :title="$t('editEventCard.interventionId')"
              :style="returnStyle(eventSelected)"
            >
              # {{ eventSelected.details.id }}
            </div>

            <span v-if="eventSelected.eventSiblings.length > 0">
              <v-icon
                :title="$t('intInformation.siblings')"
                class="iconCell"
                :style="{ fontSize: '23px', color: 'white' }"
                >mdi-numeric-{{
                  eventSelected.eventSiblings.length + 1
                }}-box</v-icon
              >
            </span>

            <span v-if="eventSelected.details.type === 'TP'">
              <img
                :title="$t('enumIntStatus.professionalTitle')"
                src="@/assets/images/icons/tp_icon.png"
                class="v-icon iconCell"
              />
            </span>

            <span v-if="eventSelected.details.type === 'POE'">
              <img
                :title="$t('enumIntStatus.eop')"
                src="@/assets/images/icons/poe_icon.png"
                class="v-icon iconCell"
              />
            </span>
          </div>
          <div
            v-if="
              editMode &&
              eventSelected.eventSiblings.length === 0 &&
              tasksBetween.length === 0
            "
            class="buttons"
          >
            <v-btn
              icon
              small
              @click="confirmDeleteEvent(eventSelected.details.id)"
              :disabled="!editMode"
            >
              <v-icon :style="returnStyle(eventSelected)"> mdi-delete </v-icon>
            </v-btn>
            <v-btn
              v-if="!isEditing"
              icon
              small
              @click="isSpliting = !isSpliting"
              :disabled="!editMode"
            >
              <v-icon v-if="isSpliting" :style="returnStyle(eventSelected)">
                mdi-close
              </v-icon>
              <v-icon v-else :style="returnStyle(eventSelected)">
                mdi-call-split
              </v-icon>
            </v-btn>
            <v-btn
              v-if="!isSpliting"
              icon
              small
              :disabled="!editMode"
              @click="openEditDialog(event)"
            >
              <v-icon :style="returnStyle(eventSelected)"> mdi-pencil </v-icon>
            </v-btn>
            <v-btn
              v-if="!isEditing"
              icon
              small
              :disabled="!editMode"
              @click="openCreateInterFollowDialog(eventSelected.details.id)"
            >
              <v-icon :style="returnStyle(eventSelected)">
                mdi-star-plus
              </v-icon>
            </v-btn>
          </div>
        </div>
        <!-- Title event -->
        <h4 v-if="!isEditing">{{ eventSelected.course }}</h4>
        <div v-if="isEditing">
          <v-autocomplete
            light
            v-model="eventSelected.details.course.id"
            :items="courses"
            item-value="id"
            item-text="title"
            :rules="emptyField"
            persistent-hint
            single-line
            color="red darken-1"
          ></v-autocomplete>
        </div>
      </div>

      <!-- Start Dialog Confirm Delete -->
      <v-card v-if="dialogDeleteEvent" class="card-delete">
        <v-card-title class="headline">{{
          $t("crudEventInfocard.confirmDeleteEvent")
        }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="F44336" text @click="closeDelete">{{
            $t("crudCourse.cancel")
          }}</v-btn>
          <v-btn
            id="button-delete-course"
            color="F44336"
            text
            @click="deleteEventConfirm"
            >{{ $t("crudCourse.ok") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogDeleteTask" class="card-delete">
        <v-card-title class="headline">{{
          $t("crudEventInfocard.confirmDeleteTask")
        }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="F44336" text @click="closeDelete">{{
            $t("crudCourse.cancel")
          }}</v-btn>
          <v-btn
            id="button-delete-course"
            color="F44336"
            text
            @click="deleteTaskConfirm"
            >{{ $t("crudCourse.ok") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <!-- ---------------------------------------------------------- -->
      <!-- CAS 1 : on a un événement avec des sibblings et des Tâches -->
      <!-- ---------------------------------------------------------- -->
      <v-expansion-panels
        v-if="event.eventSiblings.length"
        accordion
        class="scroll-y"
      >
        <v-expansion-panel>
          <v-expansion-panel-header
            :style="
              event.details.validated
                ? {
                    backgroundColor: event.color,
                    color: '#FFFFFF',
                    fontWeight: 'bold',
                  }
                : {
                    backgroundColor: '#FFFFCC',
                    color: event.color,
                    fontWeight: 'bold',
                  }
            "
          >
            {{ event.location }} : {{ event.duration }} jour(s)
            <div v-if="editMode" class="buttons">
              <v-btn
                icon
                small
                @click="confirmDeleteEvent(event.details.id)"
                :disabled="!editMode"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-delete
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isEditing"
                icon
                small
                @click="isSpliting = !isSpliting"
                :disabled="!editMode"
              >
                <v-icon v-if="isSpliting" :style="returnStyle(eventSelected)">
                  mdi-close
                </v-icon>
                <v-icon v-else :style="returnStyle(eventSelected)">
                  mdi-call-split
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isSpliting"
                icon
                small
                :disabled="!editMode"
                @click="openEditDialog(event)"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-pencil
                </v-icon>
              </v-btn>

              <v-btn
                v-if="!isEditing"
                icon
                small
                :disabled="!editMode"
                @click="openCreateInterFollowDialog(eventSelected.details.id)"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-star-plus
                </v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <view-event-info
              :event="event.details"
              :linkedIntervention="linkedIntervention"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-for="(item, i) in event.eventSiblings" :key="i">
          <v-expansion-panel-header :style="returnStyleSibblignsView(item)">
            <div>
              {{ item.location.city }} : {{ item.course.duration }} jour(s)
              <v-icon
                class="mx-3"
                color="white"
                v-if="
                  item.course.duration > 10 &&
                  (item.type === 'TP' || item.type === 'POE')
                "
              >
                mdi-school
              </v-icon>
            </div>

            <div v-if="editMode" class="buttons">
              <v-btn
                icon
                small
                @click="confirmDeleteEvent(item.id)"
                :disabled="!editMode"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-delete
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isEditing"
                icon
                small
                @click="isSpliting = !isSpliting"
                :disabled="!editMode"
              >
                <v-icon v-if="isSpliting" :style="returnStyle(eventSelected)">
                  mdi-close
                </v-icon>
                <v-icon v-else :style="returnStyle(eventSelected)">
                  mdi-call-split
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isSpliting"
                icon
                small
                :disabled="!editMode"
                @click="openEditDialogSibblings(item.id)"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isEditing"
                icon
                small
                :disabled="!editMode"
                @click="openCreateInterFollowDialog(item.id)"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-star-plus
                </v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <view-event-info
              :event="item"
              :linkedIntervention="linkedIntervention"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-for="(item, j) in tasksBetween" :key="'T-1-' + j">
          <v-expansion-panel-header>
            {{ $t("headerInfoCard.taskName") }} : {{ item.title }}
            <div v-if="editMode" class="buttons">
              <v-btn
                icon
                small
                @click="confirmDeleteTask(item.details.id)"
                :disabled="!editMode"
              >
                <v-icon class="taskIconColor"> mdi-delete </v-icon>
              </v-btn>

              <v-btn
                v-if="!isSpliting"
                icon
                small
                :disabled="!editMode"
                @click="openEditTask(item)"
              >
                <v-icon class="taskIconColor"> mdi-pencil </v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <task-info :task="item" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <v-expansion-panel v-for="(item, i) in event.eventSiblings" :key="i"> -->
      </v-expansion-panels>

      <!-- -------------------------------------------------------------------------- -->
      <!-- CAS 2 : On a un événement sans sibblings MAIS avec une ou plusieurs Tâches -->
      <!-- -------------------------------------------------------------------------- -->
      <v-expansion-panels
        v-else-if="!event.eventSiblings.length && tasksBetween.length"
        accordion
        class="scroll-y"
      >
        <v-expansion-panel>
          <v-expansion-panel-header
            :style="
              event.details.validated
                ? {
                    backgroundColor: event.color,
                    color: '#FFFFFF',
                    fontWeight: 'bold',
                  }
                : {
                    backgroundColor: '#FFFFCC',
                    color: event.color,
                    fontWeight: 'bold',
                  }
            "
          >
            {{ event.location }}
            <div v-if="editMode" class="buttons">
              <v-btn
                icon
                small
                @click="confirmDeleteEvent(event.details.id)"
                :disabled="!editMode"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-delete
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isEditing"
                icon
                small
                @click="isSpliting = !isSpliting"
                :disabled="!editMode"
              >
                <v-icon v-if="isSpliting" :style="returnStyle(eventSelected)">
                  mdi-close
                </v-icon>
                <v-icon v-else :style="returnStyle(eventSelected)">
                  mdi-call-split
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isSpliting"
                icon
                small
                :disabled="!editMode"
                @click="openEditDialog(event)"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn
                v-if="!isEditing"
                icon
                small
                :disabled="!editMode"
                @click="openCreateInterFollowDialog(eventSelected.details.id)"
              >
                <v-icon :style="returnStyle(eventSelected)">
                  mdi-star-plus
                </v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <view-event-info
              :event="event.details"
              :linkedIntervention="linkedIntervention"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-for="(item, l) in tasksBetween" :key="'T-2-' + l">
          <v-expansion-panel-header>
            {{ $t("headerInfoCard.taskName") }} : {{ item.title }}
            <div v-if="editMode" class="buttons">
              <v-btn
                icon
                small
                @click="confirmDeleteTask(item.details.id)"
                :disabled="!editMode"
              >
                <v-icon class="taskIconColor"> mdi-delete </v-icon>
              </v-btn>
              <v-btn
                v-if="!isSpliting"
                icon
                small
                :disabled="!editMode"
                @click="openEditTask(item)"
              >
                <v-icon class="taskIconColor"> mdi-pencil </v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <task-info :task="item" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- ------------------------------------------------------- -->
      <!-- CAS 3 : On a un événement sans sibblings et sans Tâches -->
      <!-- ------------------------------------------------------- -->
      <div v-else class="scroll-y">
        <view-event-info
          :event="event.details"
          :linkedIntervention="linkedIntervention"
        />
      </div>

      <!-- End Dialog Confirm Delete -->
      <div class="foot-card">
        <div v-if="errors">
          <v-card-text>
            <ul class="errorsEdit">
              <li v-for="e in errorBackend" :key="e.valueE">{{ e.valueE }}</li>
            </ul>
          </v-card-text>
        </div>

        <v-card-actions v-if="isEditing">
          <v-spacer></v-spacer>

          <v-btn text @click="closeEvent">
            {{ $t("editEventCard.cancel") }}
          </v-btn>

          <v-btn text color="success" @click="saveEvent">
            {{ $t("editEventCard.save") }}
          </v-btn>
        </v-card-actions>

        <v-snackbar v-model="hasSaved" :timeout="2000" absolute bottom left>
          {{ $t("editEventCard.snackbar") }}
        </v-snackbar>
      </div>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EditEventInfo from "./EditEventInfo.vue";
import ViewEventInfo from "./ViewEventInfo.vue";
import SplitEventInfo from "./SplitEventInfo.vue";
import AddEventCard from "../add-event/AddEventCard.vue";
import TaskInfo from "./taskInfo.vue";

export default {
  props: {
    selected: false,
    // Why there is not selectedElement when in fact it is in the component v-bind?
    event: {
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      userType: null,
      location: null,
      course: null,
      userName: null,
      eventSiblings: [],
    },
    editMode: true,
    iconEventStatus: "",
  },
  components: {
    ViewEventInfo,
    EditEventInfo,
    SplitEventInfo,
    AddEventCard,
    TaskInfo,
  },
  data() {
    return {
      dialogDeleteEvent: false,
      dialogDeleteTask: false,
      mySelect: this.selected,
      emptyField: [(v) => !!v || this.$t("errorFrontEnd.requiredField")],
      datePickerStart: false,
      datePickerEnd: false,
      timePickerStart: false,
      timePickerEnd: false,
      isEditing: false,
      isSpliting: false,
      hasSaved: false,
      status: [
        { id: "INTERN", name: "Interne" },
        { id: "INTRA", name: "Externe" },
        { id: "POE", name: "Poe" },
        { id: "TP", name: "TitrePro" },
        { id: "SOUS_TRAITANT", name: "SousTraitant" },
      ],
      errors: false,
      linkToMaster: false,
      // eventSiblingsObject: [],
      // eventSiblingsCard: [],
    };
  },
  watch: {
    event: function (v) {
      // this.createSibPagination(v);
      this.setEventSelected(v);
      this.setTasksBetweenDatesForUser({
        dateStart: this.event.x,
        duration: this.event.duration,
        userY: this.event.y,
      });
      this.getQuotations(this.event);
    },
    selectedTask: function () {
      this.setTasksBetweenDatesForUser({
        dateStart: this.event.x,
        duration: this.event.duration,
        userY: this.event.y,
      });
    },
  },
  mounted() {
    // this.createSibPagination(this.event);
    this.setEventSelected(this.event);
    this.setTasksBetweenDatesForUser({
      dateStart: this.event.x,
      duration: this.event.duration,
      userY: this.event.y,
    });
    this.getQuotations(this.event);
  },
  computed: {
    ...mapGetters("courseModule", { courses: "getCourses" }),
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("userModule", { users: "getUsers" }),
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),
    ...mapGetters("eventModule", {
      masterInterventions: "getMasterEvents",
      events: "getEvents",
      eventSelected: "getEventSelected",
      getEventById: "getEventById",
    }),
    ...mapGetters("taskModule", {
      tasksBetween: "getTasksByDatesForUser",
      selectedTask: "getSelectedTask",
    }),
  },
  methods: {
    ...mapActions("eventModule", [
      "editEvent",
      "deleteEvent",
      "setEventSelected",
      "getQuotations",
    ]),
    ...mapActions("notificationModule", [
      "showNotification",
      "emptyErrorMessages",
    ]),
    ...mapActions("taskModule", ["setTasksBetweenDatesForUser", "deleteTask"]),
    // /**
    //  * This method will create a pagination when the selected event has siblings.
    //  * The pagination will be display at the bottom of the event detail view.
    //  *
    //  * @param  {Object - event Front-End} event event selected by the client while clicking on one GridEvent
    //  * @returns {} nothing but it will fill eventSiblingsCard with the number of siblings (including the selected event)
    //  */
    // createSibPagination(event) {
    //   if (event.eventSiblings.length > 0) {
    //     this.eventSiblingsObject = this.events.filter((e) =>
    //       event.eventSiblings.includes(e.details.id)
    //     );
    //     console.log(this.eventSiblingsObject);
    //     this.eventSiblingsCard = event.eventSiblings;
    //   }
    // },
    openEditDialog(event) {
      this.$emit("eventEdit", event);
    },
    openEditDialogSibblings(id) {
      let event = this.getEventById(id);
      this.$emit("eventEdit", event);
    },
    openEditTask(task) {
      this.$emit("taskEdit", task);
    },
    openCreateInterFollowDialog(id) {
      let event = this.getEventById(id);
      this.$emit("openCreate", event);
    },
    shareKey() {
      this.$emit("eventInfoCardEdit", key);
    },
    async saveEvent() {
      this.emptyErrorMessages(); // when close by clicking on the side
      await this.editEvent(this.eventSelected.details).then((e) => {
        if (this.errorBackend.length === 0) {
          this.closeEvent();
          this.$emit("close");
          this.showNotification({
            messageAlert: this.$t("messageStores.eventEditSuccess"),
            typeAlert: "success",
          });
        } else {
          this.errors = true;
        }
      });
    },
    confirmDeleteEvent(event) {
      this.dialogDeleteEvent = true;
      this.deletedEventTemp = event;
    },
    confirmDeleteTask(task) {
      this.dialogDeleteTask = true;
      this.deletedTaskTemp = task;
    },
    deleteEventConfirm() {
      this.dialogDeleteEvent = false;
      this.$emit("close");
      this.deleteEvent(this.deletedEventTemp);
      this.deletedEventTemp, "event";
      this.closeEvent();
    },
    deleteTaskConfirm() {
      this.dialogDeleteTask = false;
      this.$emit("close");
      this.deleteTask(this.deletedTaskTemp);
      this.deletedTaskTemp, "task";
      this.closeEvent();
    },
    closeDelete() {
      this.dialogDeleteEvent = false;
      this.dialogDeleteTask = false;
    },
    closeEvent() {
      this.isEditing = false;
      this.errors = false;
    },
    isLinked() {
      return this.eventSelected.details.masterInterventions > 0;
    },
    linkedIntervention() {
      const masterIntervention = this.masterInterventions.find(
        (i) => i.id == this.eventSelected.details.masterInterventionId
      );
      if (masterIntervention)
        // return `${masterIntervention.id} - ${masterIntervention.slug}`;
        return `${masterIntervention.slug}`;
    },
    // /**
    //  * When the client click on the pagination to see one sibling of the selected event this method will be called.
    //  * This method will update the event display in the detail view card.
    //  *
    //  * @param  {Object - event Front-End} value selected page by the client
    //  * @returns {} nothing but it will update the detail view card with the sibling selected thanks to the page
    //  */
    // handlePageChange(value) {
    //   this.page = value;
    //   // Find id of the sibling
    //   let idSibling = this.eventSiblingsCard[this.page - 1];
    //   // Recover sibling thanks to its id
    //   let event = this.events.find((e) => e.id === idSibling);
    //   this.setEventSelected(event);
    // },
    returnToInfo() {
      this.isSpliting = false;
      this.isEditing = false;
    },

    returnIconStatus() {
      switch (this.selectedEvent.details.type) {
        case "POE":
          this.iconEventStatus = "";
          break;
        case "TP":
          this.iconEventStatus = "mdi-school";
          break;
        default:
          break;
      }
    },
    returnStyle(evt) {
      return !evt.details.validated && evt.eventSiblings.length == 0
        ? { color: "grey" }
        : evt.eventSiblings.length > 0
        ? { color: "white" }
        : "";
    },

    returnStyleSibblignsView(item) {
      return item.validated
        ? {
            backgroundColor: item.location.color,
            color: "#FFFFFF",
            fontWeight: "bold",
          }
        : {
            backgroundColor: "#FFFFCC",
            color: item.location.color,
            fontWeight: "bold",
          };
    },
  },
};
</script>

<style lang="scss" scoped>
/*.v-expansion-panel-header {
  text-align: right;
}*/

.myCard {
  height: var(--height-container);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .scroll-y {
    overflow-y: scroll;
  }

  .title {
    border-radius: 20px 20px 0px 0px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    color: var(--card-color);

    .icons,
    .buttons {
      display: flex;
      color: var(--card-color);

      .v-icon {
        color: var(--card-color);
      }

      .id {
        margin: 0 5px 0 0;
      }
    }
  }

  .head-card {
    display: flex;
    justify-content: space-between;
  }

  .foot-card {
    padding: 10px 0 0 0;
    top: 100%;
    position: sticky;
  }

  .v-card__text {
    padding: 0;
  }
  .buttons {
    text-align: right;
  }

  .taskIconColor {
    color: "grey";
  }
}
</style>
